/**
 * Detect whether the application is in debug mode, as set by a localStorage
 * flag: '__debug_mode'.
 *
 * @returns {boolean} true if __debug_mode is set to true, 1, or t in localStorage.
 */
export const isDebugMode = () => {
  const debugMode = localStorage.getItem('__debug_mode');
  return debugMode === 'true' || debugMode === '1' || debugMode === 't';
};
